/**
 * BENTO SCENES — animación + registro post-render.
 *
 * Separado del render (blocks/bento-scenes.js) para NO crear ciclo con render.js:
 * este archivo importa render.js (registerPostRender) y counter.js, así que se
 * carga como SIDE-EFFECT desde los entry points (script.js y public-init.js),
 * igual que counter.js — nunca desde la cadena de import de render.js.
 *
 * Solo anima en preview/público (previewOnly) y bajo IntersectionObserver. En el
 * editor y en reduce-motion/gama baja se ve el contenido completo estático.
 */
import { store } from '../core/store.js';
import { registerPostRender } from '../core/render.js';
import { animateSingleCounter } from './counter.js';
import { prefersLightweight } from './motion-tokens.js';

function typeTerminal(root) {
    const lines = Array.prototype.slice.call(root.querySelectorAll('.term-line'));
    lines.forEach(l => { l.textContent = ''; });
    let li = 0;
    function typeLine() {
        if (li >= lines.length) return;
        const el = lines[li];
        const full = el.getAttribute('data-line') || '';
        let ci = 0;
        el.classList.add('typing');
        const iv = setInterval(() => {
            ci += 1;
            el.textContent = full.slice(0, ci);
            if (ci >= full.length) {
                clearInterval(iv);
                el.classList.remove('typing');
                li += 1;
                setTimeout(typeLine, 220);
            }
        }, 28);
    }
    typeLine();
}

function playScene(el, lightweight) {
    // Modo ligero/reduce-motion: no animamos. El contenido completo ya está en el
    // DOM (counter con su cifra, terminal con sus líneas, ticker estático).
    if (lightweight) return;
    el.classList.add('scene-playing');
    const type = el.getAttribute('data-scene');
    if (type === 'counter') {
        const n = el.querySelector('.scene-num');
        if (n) animateSingleCounter(n);
    } else if (type === 'terminal') {
        typeTerminal(el);
    } else if (type === 'gauge') {
        // Anima el anillo desde vacío (offset = circunferencia) hasta el valor.
        const fill = el.querySelector('.gg-fill');
        const off = el.getAttribute('data-off');
        if (fill && off != null) {
            fill.style.strokeDashoffset = '327';
            void fill.getBoundingClientRect(); // fuerza reflow para que la transición arranque desde vacío
            fill.style.transition = 'stroke-dashoffset 1.1s cubic-bezier(0.16, 1, 0.3, 1)';
            fill.style.strokeDashoffset = off;
        }
    }
    // ticker (marquee), bars (grow), rating/menu/avatars/map/hours/quote (reveal):
    // los gobierna CSS bajo .scene-playing.
}

export function initBentoScenes() {
    if (store.get('editorMode')) return; // en el editor: estático, para no molestar al editar
    const scenes = document.querySelectorAll('.bento-scene[data-scene]');
    if (!scenes.length) return;
    const lightweight = prefersLightweight();
    const obs = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !entry.target.dataset.played) {
                entry.target.dataset.played = '1';
                playScene(entry.target, lightweight);
                obs.unobserve(entry.target);
            }
        });
    }, { threshold: 0.25 });
    scenes.forEach(s => obs.observe(s));
}

registerPostRender(initBentoScenes, { previewOnly: true });
